import * as Highcharts from "highcharts";
// chart with 2 lines
import { GenericUtils } from "./../../../utilities/generic-utils";
const genericUtils = new GenericUtils();
export const chartData = {
  credits: { enabled: false },
  chart: { zoomType: "xy" },
  title: {
    text: ""
  },
  xAxis: [
    {
      categories: ["1Jul", "2Jul", "3Jul", "4Jul", "5Jul", "6Jul", "7Jul", "8Jul", "9Jul", "10Jul", "11Jul"],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        style: { fontSize: "12px" },

        format: "{value}"
      },
      title: {
        text: "No. of units"
      }
    },
    {
      visible: false
    }
  ],
  tooltip: {
    shared: false,
    formatter: function() {
      return `Total Units Ordered: ${this.point.myData.total ? genericUtils.amountIndianUnit(this.point.myData.total) : 0} <br/>
      Delivered: ${this.point.myData.delivered ? genericUtils.amountIndianUnit(this.point.myData.delivered) : 0}<br>
      In Transit: ${this.point.myData.in_transit ? genericUtils.amountIndianUnit(this.point.myData.in_transit) : 0}<br>
      BBND: ${this.point.myData.invoiced ? genericUtils.amountIndianUnit(this.point.myData.invoiced) : 0}<br>
      To Be invoiced: ${this.point.myData.to_be_invoiced ? genericUtils.amountIndianUnit(this.point.myData.to_be_invoiced) : 0}`;
    }
  },
  plotOptions: {
    line: {
      lineWidth: 2,
      dataLabels: {
        enabled: true,
        formatter: function() {
          if (this.point.x == this.series.data.length - 1) {
            return `Target (${this.y}%)`;
          }
        },
        style: {
          color: "#626262",
          fontSize: "12px",
          fontWeight: "normal"
        }
      },
      enableMouseTracking: true,
      marker: {
        enabled: false
      }
    }
  },
  legend: {
    enabled: true,
    itemMarginTop: 10,
    itemMarginBottom: -20,
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal"
    }
  },
  series: [
    {
      name: "Total units ordered",
      type: "line",
      data: [
        { y: 24, dataPoint: {} },
        { y: 33, dataPoint: {} },
        { y: 46, dataPoint: {} },
        { y: 76, dataPoint: {} },
        { y: 13, dataPoint: {} },
        { y: 18, dataPoint: {} }
      ],
      color: "#007FD8",
      dataLabels: {
        enabled: false
      }
    },
    {
      name: "Units invoiced",
      type: "line",
      yAxis: 1,
      data: [
        { y: 32, dataPoint: {} },
        { y: 21, dataPoint: {} },
        { y: 31, dataPoint: {} },
        { y: 67, dataPoint: {} },
        { y: 87, dataPoint: {} },
        { y: 34, dataPoint: {} }
      ],
      color: "#EAC843",
      dataLabels: {
        enabled: false
      }
    },
    {
      name: "Units delivered",
      type: "line",
      yAxis: 1,
      data: [4, 4, 4, 4, 4, 4],
      color: "#2CB46C",
      dataLabels: {
        enabled: false
      }
    }
  ]
};
